// Module
var code = "<div id=\"contenedorComentariosDentro\"> <div class=\"row\" style=\"padding:0;width:100%\"> <div class=\"twelve\" ng-if=\"contComent.id\" id=\"{{contComent.id}}\"> </div> </div> </div>";
// Exports
module.exports = code;